import React, { useContext } from "react";
import { LanguageContext } from "../../../../contexts/LanguageContext";
import { translations } from "../../../../translations";
import aiBackgroundImage from "../../../../assets/ai-learning-image.jpg";

const AIPoweredLearning = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  const aiFeatures = [
    {
      title: t.aiLearning.features.personalizedFeedback.title,
      description: t.aiLearning.features.personalizedFeedback.description,
      icon: "🎯",
    },
    {
      title: t.aiLearning.features.analytics.title,
      description: t.aiLearning.features.analytics.description,
      icon: "🔍",
    },
    {
      title: t.aiLearning.features.language.title,
      description: t.aiLearning.features.language.description,
      icon: "🗣️",
    },
    {
      title: t.aiLearning.features.content.title,
      description: t.aiLearning.features.content.description,
      icon: "✨",
    },
    {
      title: t.aiLearning.features.progress.title,
      description: t.aiLearning.features.progress.description,
      icon: "🏆",
    },
    {
      title: t.aiLearning.features.tutors.title,
      description: t.aiLearning.features.tutors.description,
      icon: "👩‍🏫",
    },
  ];

  return (
    <section
      id="ai-powered-learning"
      className="ai-learning-section"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${aiBackgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="ai-learning-content">
        <h2>{t.aiLearning.title}</h2>
        <p className="section-description">{t.aiLearning.description}</p>
        <div className="ai-features-grid">
          {aiFeatures.map((feature, index) => (
            <div key={index} className="ai-feature-card">
              <div className="ai-feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AIPoweredLearning;
